/* /assets/customer-car.js
   Customer car page: gallery lightbox (PhotoSwipe via the theme's
   LoadPhotoswipe loader, same UI as product zoom) and the "+N" reveal. */
(function () {
  'use strict';

  if (customElements.get('customer-car')) return;

  class CustomerCar extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-gallery-item]'));
      if (!this.items.length) return;

      this.gallery = this.querySelector('[data-gallery]');
      this.thumbsTemplate = this.querySelector('[data-cc-thumbs]');

      this.items.forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          if (item.querySelector('[data-gallery-more]')) {
            this.reveal();
            return;
          }
          this.open(parseInt(item.dataset.index, 10) || 0);
        });
        item.addEventListener('keyup', (e) => {
          if (e.code === 'Enter') {
            e.preventDefault();
            this.open(parseInt(item.dataset.index, 10) || 0);
          }
        });
      });

      const expand = this.querySelector('[data-gallery-expand]');
      if (expand) expand.addEventListener('click', () => this.reveal());
    }

    reveal() {
      this.items.forEach((item) => item.classList.remove('is-collapsed'));
      const more = this.querySelector('[data-gallery-more]');
      if (more) more.remove();
      const holder = this.querySelector('[data-gallery-more-holder]');
      if (holder) holder.remove();
    }

    colorScheme() {
      if (!this.gallery) return '';
      return Array.from(this.gallery.classList).find((c) => c.indexOf('color-scheme') === 0) || '';
    }

    open(index) {
      const item = this.items[index];
      if (!window.theme || !window.theme.LoadPhotoswipe || !document.querySelector('.pswp')) {
        window.location.href = item.href;
        return;
      }

      const slides = this.items.map((el) => {
        const img = el.querySelector('img');
        return {
          src: el.dataset.src,
          msrc: img ? img.currentSrc || img.src : el.dataset.src,
          w: parseInt(el.dataset.width, 10) || 2400,
          h: parseInt(el.dataset.height, 10) || 1600
        };
      });

      const scheme = this.colorScheme();
      const options = {
        history: false,
        focus: false,
        index: index,
        mainClass: 'pswp-zoom-gallery pswp--customer-car' + (slides.length === 1 ? ' pswp-zoom-gallery--single' : '') + (scheme ? ' ' + scheme : ''),
        showHideOpacity: true,
        hideAnimationDuration: 250,
        closeOnScroll: false,
        closeOnVerticalDrag: false,
        captionEl: false,
        closeEl: true,
        closeElClasses: ['caption-close', 'title'],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        maxSpreadZoom: 2,
        loop: true,
        spacing: 0,
        allowPanToNext: true,
        pinchToClose: false,
        getThumbBoundsFn: () => {
          const rect = item.getBoundingClientRect();
          const scrollY = window.scrollY || document.documentElement.scrollTop;
          return { x: rect.left, y: rect.top + scrollY, w: rect.width };
        }
      };

      new window.theme.LoadPhotoswipe(slides, options);

      const thumbs = document.querySelector('.pswp__thumbs');
      if (thumbs && this.thumbsTemplate) {
        thumbs.innerHTML = this.thumbsTemplate.innerHTML;
      }
    }
  }

  customElements.define('customer-car', CustomerCar);
})();
